import { useState } from 'react';
import { Globe, Check } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useI18n } from '../i18n';
import { toast } from 'sonner';

export function LanguageSwitcher({ compact = false }) {
  const { locale, setLocale, available, names, t } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid="lang-switcher-trigger" variant="ghost" size={compact ? 'icon' : 'sm'} className="text-[color:var(--alb-text)] hover:bg-[color:var(--alb-surface-2)] gap-1">
          <Globe className="h-4 w-4" />
          {!compact && <span className="uppercase text-xs font-semibold">{locale}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-[color:var(--alb-surface)] border-[color:var(--alb-hairline)] max-h-[60vh] overflow-y-auto">
        <DropdownMenuLabel>{t('lang.selector_label')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {available.map((code) => (
          <DropdownMenuItem
            key={code}
            data-testid={`lang-option-${code}`}
            onClick={() => { setLocale(code); toast.success(t('lang.changed')); }}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <span className="uppercase text-xs font-mono-tab w-7 inline-block text-[color:var(--alb-text-muted)]">{code}</span>
              <span>{names[code] || code}</span>
            </span>
            {locale === code && <Check className="h-4 w-4 text-[color:var(--alb-sun)]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
